import { render, staticRenderFns } from "./addCourseAuth.vue?vue&type=template&id=2feeb8a7&scoped=true&"
import script from "./addCourseAuth.vue?vue&type=script&lang=js&"
export * from "./addCourseAuth.vue?vue&type=script&lang=js&"
import style0 from "./addCourseAuth.vue?vue&type=style&index=0&id=2feeb8a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feeb8a7",
  null
  
)

export default component.exports